import { Figure } from "./Primitives";
import { ArrowRight, PenLine } from "lucide-react";

/**
 * Hero: text left, freed collage right. The artwork has a transparent ground so it
 * merges with the paper – no image card, no white box. Construction lines run out
 * of the motif into the page grid.
 */
export const Hero = ({ texts, heroMediaId, heroImage }) => (
  <section
    data-testid="hero-section"
    className="relative overflow-hidden border-b border-paper-line pt-[72px]"
  >
    <div className="pointer-events-none absolute inset-0 ap-grid-bg opacity-70" aria-hidden="true" />

    {/* construction lines continuing the motif into the grid */}
    <div className="pointer-events-none absolute inset-0 hidden lg:block" aria-hidden="true">
      <span className="ap-hairline left-0 right-[28%] top-[32%] h-px" />
      <span className="ap-hairline left-[12%] right-0 top-[64%] h-px" />
      <span className="ap-hairline bottom-0 left-[58%] top-[18%] w-px" />
      <span className="absolute left-[58%] top-[32%] h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 bg-signal" />
      <span className="absolute right-[6%] top-[64%] h-px w-16 bg-signal" />
    </div>

    <div className="ap-container relative grid items-center gap-8 py-12 sm:py-16 lg:grid-cols-[1.02fr_0.98fr] lg:gap-6 lg:py-24">
      {/* motif: on mobile behind/below the headline, on desktop right and partly cropped */}
      <div
        className="pointer-events-none absolute inset-x-0 top-[64px] z-0 mx-auto max-w-[460px] opacity-25 sm:max-w-[560px] lg:static lg:order-2 lg:max-w-none lg:opacity-100"
        aria-hidden="true"
      >
        <div className="relative lg:-mr-[10%] lg:w-[118%]">
          <Figure
            src={heroImage}
            mediaId={heroMediaId}
            alt=""
            ratio="aspect-[4/5]"
            variant="lg"
            bare
          />
          <span className="ap-stamp absolute -top-6 left-2 hidden lg:block">AP · HERO · 01</span>
          <span className="ap-stamp absolute bottom-2 left-2 hidden lg:block">
            BLACK &amp; GREY · ARCHITEKTUR
          </span>
        </div>
      </div>

      <div className="relative z-[1] animate-rise lg:order-1">
        <p className="ap-stamp">{texts.hero_kicker}</p>
        <div className="mt-5 flex items-start gap-4">
          <span className="mt-3 hidden h-16 w-px bg-signal sm:block" aria-hidden="true" />
          <h1 className="ap-h1 text-ink">{texts.hero_h1}</h1>
        </div>
        <p className="ap-lead mt-6 max-w-xl">{texts.hero_sub}</p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a href="#motive" data-testid="hero-cta-primary" className="ap-btn-solid">
            {texts.hero_cta_primary} <ArrowRight size={16} />
          </a>
          <a href="#anfrage" data-testid="hero-cta-secondary" className="ap-btn-ghost">
            <PenLine size={16} /> {texts.hero_cta_secondary}
          </a>
        </div>

        <dl className="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-paper-line pt-6">
          {[
            ["12", "Jahre Erfahrung"],
            ["1:1", "Persönliche Beratung"],
            ["AT", "St. Ruprecht a. d. Raab"],
          ].map(([k, v]) => (
            <div key={v}>
              <dt className="font-display text-2xl font-black text-ink sm:text-3xl">{k}</dt>
              <dd className="ap-stamp mt-1 leading-snug">{v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  </section>
);
